/**
 * Year Filter & Message Viewer for Parents Page
 *
 * 1. Notices year filter: filters PDF cards by school year
 * 2. Message year filter: switches the message list by year
 * 3. Message list: clicking a message item shows its content on the right
 */
export default function initYearFilter() {

  // ── 1. Notices year filter ──────────────────────────────────────
  const noticeFilter = document.querySelector('[data-year-filter]');
  if (noticeFilter) {
    const tabs  = noticeFilter.querySelectorAll('[data-year]');
    const cards = document.querySelectorAll('[data-year-item]');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const selected = tab.dataset.year;

        tabs.forEach(t => t.classList.remove('parents-year-tab--active'));
        tab.classList.add('parents-year-tab--active');

        cards.forEach(card => {
          if (!selected || card.dataset.yearItem === selected) {
            card.removeAttribute('hidden');
          } else {
            card.setAttribute('hidden', '');
          }
        });
      });
    });
  }

  // ── 2. Message year filter ──────────────────────────────────────
  const msgYearBtns  = document.querySelectorAll('[data-msg-year]');
  const msgYearGroups = document.querySelectorAll('[data-msg-year-group]');

  if (msgYearBtns.length) {
    msgYearBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const year = btn.dataset.msgYear;

        // Update active year button
        msgYearBtns.forEach(b => b.classList.remove('parents-msg-year--active'));
        btn.classList.add('parents-msg-year--active');

        // Update list header
        const listHeader = document.querySelector('[data-msg-list-header]');
        if (listHeader) listHeader.textContent = year + '年メッセージ一覧';

        // Show matching year group in list, hide others
        msgYearGroups.forEach(group => {
          group.classList.toggle('parents-msg-year-group--active', group.dataset.msgYearGroup === year);
        });

        // Auto-select first message in that year
        const activeGroup = document.querySelector(`[data-msg-year-group="${year}"]`);
        if (activeGroup) {
          const firstItem = activeGroup.querySelector('[data-msg-id]');
          if (firstItem) firstItem.click();
        }
      });
    });
  }

  // ── 3. Message list item selection ─────────────────────────────
  const msgItems   = document.querySelectorAll('[data-msg-id]');
  const msgDetails = document.querySelectorAll('[data-msg-detail]');

  if (msgItems.length) {
    msgItems.forEach(item => {
      item.addEventListener('click', () => {
        const id = item.dataset.msgId;

        // Update active item
        msgItems.forEach(i => i.classList.remove('parents-msg-item--active'));
        item.classList.add('parents-msg-item--active');

        // Show matching detail, hide others
        msgDetails.forEach(detail => {
          detail.classList.toggle('parents-msg-detail--active', detail.dataset.msgDetail === id);
        });
      });
    });
  }
}
